import type { RecipesListParams } from '../../services/recipe/recipe.service';

export const recipeQueryKeys = {
  all: ['recipes'] as const,
  list: () => ['recipes', 'list'] as const,
  /** Server-side paginated/searchable list backing the main page — distinct
   * from `list()`, which is the unpaginated full array pickers still rely on. */
  paginated: (params: RecipesListParams) => ['recipes', 'paginated', params] as const,
  detail: (id: string) => ['recipes', 'detail', id] as const,
  nutrition: (id: string) => ['recipes', 'nutrition', id] as const,
  prepackagedTemplate: (id: string) => ['recipes', 'prepackaged-template', id] as const,
};

export const allergenQueryKeys = {
  all: ['allergens'] as const,
  list: () => ['allergens', 'list'] as const,
};

export const recipeCategoryQueryKeys = {
  all: ['recipeCategories'] as const,
  list: () => ['recipeCategories', 'list'] as const,
};
